<div class="section">
  <ng-container>
    <h1 class="section-title">Users</h1>
    <div class="users-list">
      <app-user-card
        *ngFor="let user of userList"
        [user]="user"
      ></app-user-card>
    </div>
    <app-primary-btn
      (click)="getUsers()"
      [buttonTitle]="'Reload Users'"
      [buttonIcon]="buttonIcon"
      [loader]="loader"
    ></app-primary-btn>
  </ng-container>
</div>

<app-loader *ngIf="loader"></app-loader>
